import React from 'react';
import { Box, Heading, Card, Text, ExternalLink } from '../core';
import {
  IChain,
  generateStrategyDescription,
  getExplorerUrl,
} from '@sc1/common';
import { Strategy } from '@sc1/common/gql/types';
import { useBreakpointIndex } from '@theme-ui/match-media';
import { ExternalLinkIcon } from '../icons/ExternalLinkIcon';
import type { CardProps } from 'theme-ui';

interface StrategyDescriptionProps extends CardProps {
  strategy: Partial<Strategy>;
  chain: IChain;
}

export const StrategyDescription = ({
  strategy,
  chain,
  sx,
  ...rest
}: StrategyDescriptionProps): JSX.Element | null => {
  const description = generateStrategyDescription(
    strategy?.name,
    strategy?.symbol,
    chain
  );
  const mobile = useBreakpointIndex() === 0;
  const explorer = getExplorerUrl(chain);
  const url = `${explorer}address/${strategy?.id}`;
  if (!description) return null;
  return (
    <Card
      variant="small"
      sx={{ fontSize: 1, fontWeight: 600, ...sx }}
      {...rest}
    >
      <Box>
        <ExternalLink postfix={<ExternalLinkIcon />} href={url}>
          <Heading as="h3" sx={{ fontWeight: 600 }}>
            {description.customName}
          </Heading>
        </ExternalLink>
        <Box sx={{ mb: 2 }} />

        <Box mb={1} color="secondary" sx={{ fontSize: 1 }}>
          {description.summary}
        </Box>
        {description.steps &&
          !mobile &&
          description.steps.map((step) => (
            <Box key={step} sx={{ color: 'grey', fontSize: 1 }}>
              <Text>{step}</Text>
            </Box>
          ))}
      </Box>
    </Card>
  );
};
